// @flow
import Container from "@material-ui/core/Container";
import {
  SuspenseWithPerf,
  useAuth,
  useFirestore,
  useFirestoreDocData,
  useFirestoreDocDataOnce,
} from "reactfire";
import React from "react";
import BackdropLoading from "../../components/BackdropLoading";
import { useParams } from "react-router-dom";
import TicketReservationForm from "./TicketReservationForm";
import TicketReservationHeader from "./TicketReservationHeader";
import Helmet from "react-helmet";
import Skeleton from "@material-ui/lab/Skeleton";
import gameSelectors from "../../selectors/gameSelectors";
import ticketReservationSelectors from "../../selectors/ticketReservationSelectors";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import dev from "../../common/dev";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      backgroundColor: theme.palette.background.paper,
    },
  })
);

function TicketReservation() {
  const { gameId } = useParams();
  const firestore = useFirestore();
  const auth = useAuth();

  const gameRef = firestore.collection("games").doc(gameId);
  const game = useFirestoreDocData(gameRef);
  const team = useFirestoreDocDataOnce(
    firestore.collection("teams").doc(game.teamId)
  );
  const opponent = useFirestoreDocDataOnce(
    firestore.collection("opponents").doc(game.opponentId)
  );
  const location = useFirestoreDocDataOnce(
    firestore.collection("locations").doc(game.locationId)
  );

  // check if there is a ticket, if so display and link, if not show fallback
  const userDataRef = firestore.collection("users").doc(auth.currentUser.uid);

  const userData = useFirestoreDocData(userDataRef);
  const hasTicket = ticketReservationSelectors.hasTicketReservation(
    userData,
    gameId
  );

  const classes = useStyles();

  if (dev.isDevMode() && hasTicket) {
    console.warn("User has a ticket and still entered reservation");
  }

  const { leftTeam, rightTeam } = gameSelectors.getLeftAndRightTeams(
    game,
    team,
    opponent
  );

  return (
    <div className={classes.wrapper}>
      <Helmet>
        <title>Tickets – SG Coesfeld 06</title>
      </Helmet>
      <SuspenseWithPerf
        traceId="TicketReservationHeader"
        fallback={<Skeleton width="100%" height={30} />}
      >
        <TicketReservationHeader
          game={game}
          leftTeam={leftTeam}
          rightTeam={rightTeam}
        />
      </SuspenseWithPerf>
      <Container maxWidth="sm">
        <SuspenseWithPerf
          traceId="TicketReservationForm"
          fallback={<BackdropLoading />}
        >
          <TicketReservationForm
            game={game}
            gameRef={gameRef}
            location={location}
          />
        </SuspenseWithPerf>
      </Container>
    </div>
  );
}

export default TicketReservation;
